<template>
	<div class="head-component" :class="[`${mode}` , `${position}`,`head-${$route.name}`, { themeWhite: scrollToWhite }]">
		<div class="head">
			<div class="head-container">
				<div class="back-box" v-if="isHaveBack" @click="back">
					<svg-icon name="back"></svg-icon>
					<div class="label">返回</div>
				</div>
				<div class="login-box" v-if="isHaveLogin">
					<template v-if="uInfo && uInfo.roles && uInfo.certifiedStatus == '2'">
						<el-popover :disabled="!uInfo.isAdmin" popper-class="workbench-popover" trigger="hover">
							<div class="enter-workbench c-pointer" slot="reference">
								<a v-if="uInfo.isAdmin">进入工作台</a>
								<a
									v-else-if="
										(!uInfo.isAdmin &&
											uInfo.roles &&
											(uInfo.roles.indexOf('manager') != -1 ||
												uInfo.username.indexOf('AdminMaster01') != -1 ||
												uInfo.username.indexOf('AdminMaster02') != -1)) ||
										uInfo.roles.indexOf('manager_userSet') != -1
									"
									href="/org/admin/"
								>
									进入工作台
								</a>
								<a v-else-if="!uInfo.isAdmin && uInfo.roles && uInfo.roles.indexOf('government') != -1" href="/org/admin/">进入工作台</a>
								<a
									v-else-if="!uInfo.isAdmin && uInfo.roles && (uInfo.roles.indexOf('authentication') != -1 || uInfo.roles.indexOf('auth_userSet') != -1)"
									href="/org/authority/"
								>
									进入工作台
								</a>
								<a
									v-else-if="!uInfo.isAdmin && uInfo.roles && (uInfo.roles.indexOf('company') != -1 || uInfo.roles.indexOf('home_userSet') != -1)"
									href="/org/home/"
								>
									进入工作台
								</a>
							</div>
							<div class="workbenchBtns">
								<a class="workbenchBtn" href="/org/admin/">运营端</a>
								<a class="workbenchBtn" href="/org/authority/">认证机构端</a>
								<a class="workbenchBtn" href="/org/home/">面客端</a>
							</div>
						</el-popover>
					</template>
					<!-- 用户下拉弹窗 -->
					<template v-if="uInfo && uInfo.certifiedStatus">
						<el-popover v-model="showUserDropdown" popper-class="user-dropdown" trigger="click">
							<div class="user" slot="reference">
								<div class="avatar">
									<img v-if="uInfo.userImage" :src="uInfo.userImage" alt="" />
									<svg-icon v-else name="headPic"></svg-icon>
								</div>
								<svg-icon name="arrowdown"></svg-icon>
							</div>
							<div class="popover-content">
								<div class="top">
									<div class="userName">{{ uInfo.name }}</div>
									<div class="company" v-if="uInfo.certifiedStatus">
										<span class="name truncate">{{ uInfo.companyName }}</span>
										<img :src="`${baseUrl}static/status${filterTag(uInfo.certifiedStatus).status}.svg`" alt />
										<span class="action" @click="gotoCertify(uInfo.certifiedStatus)">{{ filterTag(uInfo.certifiedStatus).txt }}</span>
									</div>
								</div>
								<div class="bom">
									<span @click="handelLogOut()">
										<svg-icon name="logout"></svg-icon>
										退出登录
									</span>
									<!-- <router-link tag="div" :to="{ name: 'home' }">
										<span style="color: red" @click="closeUserDropdown">返回首页</span>
									</router-link> -->
								</div>
							</div>
						</el-popover>
					</template>
					<router-link tag="div" v-else class="login-btn" :to="{ name: 'login' }">
						<el-button type="primary">登录/注册</el-button>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { LogOut } from '@/common/api.js';
export default {
	name: 'Head',
	props: {
		// 定位
		position: {
			type: String,
			default: ''
		},
		// 模式
		mode: {
			type: String,
			default: ''
		},
		// 是否显示返回
		isHaveBack: {
			type: Boolean,
			default: false
		},
		// 是否显示登录
		isHaveLogin: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			menuActiveItem: '',
			// 搜索框值
			keyword: '',
			// 用户状态
			tags: [
				{ status: '', color: '', name: '未实名', txt: '' },
				{ status: '1', color: 'orange', name: '实名中', txt: '查看详情>' },
				{ status: '2', color: 'green', name: '实名成功', txt: '' },
				{ status: '3', color: 'red', name: '实名失败', txt: '重新实名>' }
			],
			// 是否显示用户下拉弹窗
			showUserDropdown: false,
			// 滚动变白
			scrollToWhite: false,
			// 关于平台页面头部滚动变色高度
			aboutScrollHeight: ''
		};
	},
	watch: {
		$route: {
			handler(val, oldval) {
				console.log('this.$route: ', this.$route);
				this.scrollToWhite = false;
				this.showUserDropdown = false;
				if (this.checkUser()) {
					this.$store.dispatch('updateUInfo');
				}
				this.getActiveMenuItem();
			},
			deep: true,
			immediate: false
		}
	},
	created() {
		this.scrollToWhite = false;
		if (this.checkUser()) {
			this.$store.dispatch('updateUInfo');
		}
		this.getActiveMenuItem();
		this.getScrollHeight()
		
		window.addEventListener('resize', () => {
		  // console.log('窗口大小改变了');
		  // console.log('当前宽度:', window.innerWidth, '当前高度:', window.innerHeight);
		  this.getScrollHeight()
		});
		
		// 监听页面滚动，改变头部样式
		window.addEventListener('scroll', () => {
			// console.log('垂直滚动位置:', window.scrollY);
			if (this.$route.name == 'about') {
				if (window.scrollY > this.aboutScrollHeight) {
					this.scrollToWhite = true;
				} else {
					this.scrollToWhite = false;
				}
			} else if (this.$route.name == 'home') {
				if (window.scrollY > window.innerHeight - 60) {
					this.scrollToWhite = true;
				} else {
					this.scrollToWhite = false;
				}
			}
		});
	},
	mounted() {},
	methods: {
		// 返回
		back() {
			this.$emit('back')
		},
		// 获取头部滚动变色距离
		getScrollHeight() {
			setTimeout(() => {
				const htmlElement = document.documentElement;
				// 注意：这只能获取内联样式，如果font-size是通过CSS设置的，则返回空字符串
				const fontSize = htmlElement.style.fontSize;
				this.aboutScrollHeight = parseFloat(this.px2rem('308px')) * parseFloat(fontSize) 
			}, 500)
		},
		// 获取当前所属模块
		getActiveMenuItem() {
			// 首页 搜索归类到首页模块下面
			if (this.$route.matched.some(v => v.path == '/home')) {
				this.menuActiveItem = 'home';
			}
			// 资讯
			if (this.$route.matched.some(v => v.path == '/information')) {
				this.menuActiveItem = 'information';
			}
			// 技术文件
			if (this.$route.matched.some(v => v.path == '/technology')) {
				this.menuActiveItem = 'technology';
			}
			// 政策合规
			if (this.$route.matched.some(v => v.path == '/policy')) {
				this.menuActiveItem = 'policy';
			}
			// 关于平台
			if (this.$route.matched.some(v => v.path == '/about')) {
				this.menuActiveItem = 'about';
			}
			// 客户服务
			if (this.$route.matched.some(v => v.path == '/service')) {
				this.menuActiveItem = 'service';
			}
			// 搜索
			if (this.$route.matched.some(v => v.path == '/search')) {
				// 搜索没有
				this.menuActiveItem = '';
			}
		},
		// 去认证
		gotoCertify(status) {
			// status 2 实名成功
			switch (Number(status)) {
				case 0:
					// 未实名
					this.$router.push({ name: 'registerApply' });
					break;
				case 1:
					// 实名中
					this.$router.push({ name: 'applyInfo' });
					break;
				case 3:
					// 实名失败
					this.$router.push({ name: 'applyFail' });
					break;
				default:
					break;
			}
			this.showUserDropdown = false;
		},
		// 关闭用户下拉弹窗
		closeUserDropdown() {
			this.showUserDropdown = false;
		},
		// 退出登录
		handelLogOut() {
			LogOut().then((res) => {
				if (res.code === '200') {
					this.$store.commit('changeToken');
					this.$store.commit('changeUInfo');
					this.toast(res.message, 'success');
					this.$router.push({ name: 'login' });
				} else {
					this.toast(res.message, 'error');
				}
			});
		},
		// 获取状态
		filterTag(comStatus) {
			let obj = this.tags.filter((item) => item.status == Number(comStatus));
			return obj[0];
		},

		// // 获取用户信息
		// getUser() {
		//   const res = await userInfo()
		//   if (res.success) {
		//     user.value = res.data
		//     storage.set('dl_userInfo', res.data)
		//     emits('update:userInfo')
		//   } else {
		//     Message.error(res.message);
		//   }
		// },

		// 搜索
		search() {
			this.$store.commit('changeSearchKeyword', this.keyword);
			this.$router.push({ name: 'search' });
			this.keyword = '';
		}
	}
};
</script>

<style lang="scss">
.user-dropdown {
	padding: 0;
}
.workbench-popover {
	padding: 0;
}
</style>
<style lang="scss" scoped>
.head-component {
	&.sticky {
		height: $head-height;
		position: sticky;
		z-index: 999;
		top: 0;
	}
	&.absolute {
		height: $head-height;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		z-index: 999;
		top: 0;
	}
	&.black {
		.head {
			width: 100%;
			height: $head-height;
			display: flex;
			// background-color: rgba(0, 0, 0, 0.1);
			box-sizing: border-box;
			// border-bottom: 1px solid;
			// border-color: rgb(242, 243, 245, 0.2);
			// background: rgba(0, 0, 0, 0);
			// backdrop-filter: blur(10px);
		
			.head-container {
				width: 100%;
				display: flex;
				.back-box {
					width: 250px;
					height: 60px;
					background: transparent;
					display: flex;
					align-items: center;
					cursor: pointer;
					.svg-back {
						margin-left: 90px;
						width: 28px;
						height: 22px;
						fill: #333333;
					}
					.label {
						margin-left: 20px;
						font-size: 16px;
						color: #333333;
					}
				}
				.login-box {
					margin-left: auto;
					display: flex;
					align-items: center;
					.enter-workbench {
						font-size: 14px;
						color: #ffffff;
						margin-left: 10px;
						height: $head-height;
						line-height: $head-height;
						a {
							font-size: 14px;
							color: #ffffff;
						}
					}
					.user {
						display: flex;
						align-items: center;
						height: $head-height;
						cursor: pointer;
						margin-left: 10px;
						.avatar {
							width: 40px;
							height: 40px;
							img {
								width: 100%;
								height: 100%;
								border-radius: 50%;
							}
							.svg-icon {
								width: 100%;
								height: 100%;
								border-radius: 50%;
							}
						}
						.svg-arrowdown {
							margin-left: 10px;
							width: 20px;
							height: 10px;
							fill: #ffffff;
						}
					}
					.login-btn {
						display: flex;
						margin-right: 40px;
						.el-button {
							align-self: center;
							margin-left: 10px;
							display: flex;
							justify-content: center;
							align-items: center;
							padding: 0;
							width: 114px;
							height: 40px;
							border-radius: 4px;
							// font-weight: bold;
							font-size: 14px;
							line-height: 20px;
						}
					}
				}
			}
		}
	}
	&.white {
		.head {
			width: 100%;
			height: $head-height;
			display: flex;
			// background-color: rgba(0, 0, 0, 0.1);
			box-sizing: border-box;
			// border-bottom: 1px solid;
			// border-color: rgb(242, 243, 245, 0.2);
			// background: rgba(0, 0, 0, 0);
			// backdrop-filter: blur(10px);
		
			.head-container {
				width: 100%;
				display: flex;
				.back-box {
					width: 250px;
					height: 60px;
					background: rgba(#FFFFFF, 0.05);
					display: flex;
					align-items: center;
					cursor: pointer;
					.svg-back {
						margin-left: 90px;
						width: 28px;
						height: 22px;
						fill: #ffffff;
					}
					.label {
						margin-left: 20px;
						font-size: 16px;
						color: #FFFFFF;
					}
				}
				.login-box {
					margin-left: auto;
					display: flex;
					align-items: center;
					.enter-workbench {
						font-size: 14px;
						color: #ffffff;
						margin-left: 10px;
						height: $head-height;
						line-height: $head-height;
						a {
							font-size: 14px;
							color: #ffffff;
						}
					}
					.user {
						display: flex;
						align-items: center;
						height: $head-height;
						cursor: pointer;
						margin-left: 10px;
						.avatar {
							width: 40px;
							height: 40px;
							img {
								width: 100%;
								height: 100%;
								border-radius: 50%;
							}
							.svg-icon {
								width: 100%;
								height: 100%;
								border-radius: 50%;
							}
						}
						.svg-arrowdown {
							margin-left: 10px;
							width: 20px;
							height: 10px;
							fill: #ffffff;
						}
					}
					.login-btn {
						display: flex;
						margin-right: 40px;
						.el-button {
							align-self: center;
							margin-left: 10px;
							display: flex;
							justify-content: center;
							align-items: center;
							padding: 0;
							width: 114px;
							height: 40px;
							border-radius: 4px;
							// font-weight: bold;
							font-size: 14px;
							line-height: 20px;
						}
					}
				}
			}
		}
	}
	
}
</style>

<style lang="scss" scoped>
	// 工作台弹窗
	.workbench-popover {
		.workbenchBtns {
			height: 100%;
			width: 100%;
			// background-color: red;
			display: flex;
			flex-direction: column;
			padding: 10px 0;
	
			.workbenchBtn {
				width: 100%;
				line-height: 40px;
				color: rgb(0, 143, 80);
				text-align: center;
				font-size: 16px;
			}
		}
	}
</style>
<style lang="scss" scoped>
	// 用户下拉弹窗
	.user-dropdown {
		.popover-content {
			.top {
				height: 100px;
				padding: 12px 16px;
				border-bottom: 1px solid rgb(242, 243, 245);
			}
	
			.bom {
				padding: 12px 16px;
				color: rgb(29, 33, 41);
				display: flex;
				justify-content: space-between;
				align-items: center;
				cursor: pointer;
				.svg-logout {
					margin-right: 6px;
					width: 20px;
					height: 10px;
				}
			}
	
			.userName {
				font-size: 20px;
				color: rgb(29, 33, 41);
				line-height: 28px;
			}
	
			.company {
				font-size: 14px;
				color: rgb(78, 89, 105);
				line-height: 20px;
				margin-top: 6px;
				display: flex;
	
				.name {
					margin-right: 6px;
					flex: 1;
				}
	
				.action {
					font-size: 12px;
					margin-left: auto;
					text-align: right;
					color: rgb(0, 153, 68);
					cursor: pointer;
					width: 80px;
				}
				
				img {
					height: 20px;
				}
			}
		}
	}
</style>
